import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'
import { AssetName } from 'main/util/asset'

import {
  StyledLink,
  StyledStrong,
  StyledText,
  SubsidyEligibilityContainer,
  SubsidyEligibilityDivider,
  TextContainer,
} from './SubsidyEligibility.styles'

export default function SubsidyElegibility() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const whitelabel = useWhitelabel()

  const title = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_TITLE)

  const copy1 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_COPY_1)
  const link1 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_LINK_1)
  const link1Text = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_LINK_1_TEXT)

  const copy2 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_COPY_2)
  const link2 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_LINK_2)
  const link2Text = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_LINK_2_TEXT)

  const copy3 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_COPY_3)
  const link3 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_LINK_3)
  const link3Text = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_LINK_3_TEXT)

  const copy4 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_COPY_4)

  const copy5 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_COPY_5)
  const link5 = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_LINK_5)
  const link5Text = whitelabel.getAsset(AssetName.SUBSIDY_ELIGIBILITY_LINK_5_TEXT)

  if (
    !copy1 ||
    !copy2 ||
    !copy3 ||
    !copy4 ||
    !copy5 ||
    !link1Text ||
    !link2Text ||
    !link3Text ||
    !link5Text ||
    !link1 ||
    !link2 ||
    !link3 ||
    !link5 ||
    !title
  ) {
    return null
  }

  return (
    <SubsidyEligibilityContainer>
      <TextContainer>
        <StyledStrong>{t(title)}</StyledStrong>
        <div />
        <StyledText>{t(copy1)}</StyledText>
        <StyledLink href={link1} target="_blank">
          {t(link1Text)}
        </StyledLink>
        <StyledText>.</StyledText>
      </TextContainer>
      <SubsidyEligibilityDivider />
      <TextContainer>
        <StyledText>{t(copy2)}</StyledText>
        <StyledLink href={link2} target="_blank">
          {t(link2Text)}
        </StyledLink>
        <StyledText>{t(copy3)}</StyledText>
        <StyledLink href={link3} target="_blank">
          {t(link3Text)}
        </StyledLink>
        <StyledText>{t(copy4)}</StyledText>
        <StyledText> {t(copy5)} </StyledText>
        <StyledLink href={t(link5)} target="_blank">
          {t(link5Text)}
        </StyledLink>
        <StyledText>?</StyledText>
      </TextContainer>
    </SubsidyEligibilityContainer>
  )
}
